/**
 * https://github.com/validatorjs/validator.js
 */
import {RuleObject, StoreValue} from 'rc-field-form/lib/interface';
import validator from 'validator';

const CustomAntdRules = {
    MobilePhone: {
        validator: (rule: RuleObject, value: StoreValue) => {
            if (!value) return false;
            if (validator.isMobilePhone(value, 'zh-CN' as any)) {
                return true;
            }
            return false;
        },
        message: '${label}格式不正确',
    },
    Required: {
        required: true,
        message: '${label}不能为空',
    },
};

export default CustomAntdRules;
